import z from 'zod';
import { socialApiClient } from '@/shared/api-client/social-api-client';
import { filterConditionsSchema, type DiscoveryMessage } from '../schema';

export async function analyzeCommonality(
  discoverySessionId: string,
  request: AnalyzeCommonalityRequest,
  signal?: AbortSignal,
): Promise<AnalyzeCommonalityResponse> {
  const parsedRequest = analyzeCommonalityRequestSchema.parse(request);
  const response = await socialApiClient.post(
    `discovery-sessions/${discoverySessionId}/analyze-commonality`,
    {
      json: parsedRequest,
      signal,
    },
  );

  return await response.json();
}

export const analyzeCommonalityRequestSchema = z.object({
  post_id_list: z.array(z.string()).min(1).max(6),
  filter_conditions: filterConditionsSchema,
});

export type AnalyzeCommonalityResponse = {
  user_message: DiscoveryMessage;
  assistant_message: DiscoveryMessage;
};
export type AnalyzeCommonalityRequest = z.infer<typeof analyzeCommonalityRequestSchema>;
